import React from 'react'
import '../../css/dividers-svgs.css'

const VerticalDivider1 = () => {
  return (
    <div className='vertical-divider1'></div>
  )
}

export default VerticalDivider1